import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CssVariableSnippetComponent } from '../../../../shared/components/css-variable-snippet/css-variable-snippet.component';
import { StylingCardShellComponent } from '../styling-card-shell/styling-card-shell.component';

@Component({
    selector: 'avd-typography-token-card',
    standalone: true,
    templateUrl: './typography-token-card.component.html',
    styleUrls: ['./typography-token-card.component.scss'],
    imports: [StylingCardShellComponent, CssVariableSnippetComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypographyTokenCardComponent {
    @Input() cssVariable: string = '';
    @Input() label: string = '';
    @Input() longhandSnippet: string = '';
    @Input() shorthandSnippet: string = '';

    get cssVariableName(): string {
        return this.cssVariable.trim();
    }

    get typographyStyle(): string {
        return this.cssVariableName;
    }
}
